import React from 'react';
import styled from 'styled-components';
import { Fade } from 'react-awesome-reveal';
import bg1 from '../Images/bg1.jpg'

// --- STYLED COMPONENTS ---

const BannerContainer = styled.div`
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  max-width: 1200px;
  margin: 0 auto;
  padding: 10px 20px;
  background-color: #ffffff;
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  align-items: center;
  gap: 40px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    text-align: center;
    padding: 10px 20px;
  }
`;

const TextSide = styled.div`
  max-width: 520px;

  @media (max-width: 768px) {
    margin: 0 auto;
  }
`;

const HeadingText = styled.h1`
  font-size: 2.2rem;
  font-weight: 600;
  color: #439E6D; /* Deep corporate navy blue */
  line-height: 1.3;
  margin: 0;
  letter-spacing: -0.5px;

  @media (max-width: 480px) {
    font-size: 1.8rem;
  }
`;

const ImageSide = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  @media (max-width: 768px) {
    justify-content: center;
  }
`;

const StyledImage = styled.img`
  width: 100%;
  max-width: 500px;
  height: auto;
  object-fit: cover;
  border-radius: 4px; /* Optional slight smoothing for raw edges */
`;

// --- MAIN COMPONENT ---

const ServicesBanner = () => {
  return (
    <BannerContainer>
      {/* Left Text Block */}
      <TextSide>
        <Fade triggerOnce direction="left" duration={900}>
          <HeadingText>
            We advise global leaders on their most critical issues and opportunities.
          </HeadingText>
        </Fade>
      </TextSide>

      {/* Right Image Block */}
      <ImageSide>
        <Fade triggerOnce direction="right" duration={900} delay={150}>
          {/* Replace this src path with your local asset or hosted corporate image url */}
          <StyledImage 
            src={bg1} 
            alt="Global consulting advisory" 
          />
        </Fade>
      </ImageSide>
    </BannerContainer>
  );
};

export default ServicesBanner;